var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUnassign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "#3282FF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.267 3.98a.467.467 0 0 0-.001.84l.119.06h2.059c1.39 0 2.084-.009 2.134-.028a.499.499 0 0 0 .308-.456c0-.152-.06-.265-.202-.38l-.102-.083-2.098-.007-2.097-.007-.12.061m6.571.671a.385.385 0 0 0-.213.27c-.037.198-.013.231.631.879l.61.614-.6.6c-.637.636-.679.693-.642.889a.39.39 0 0 0 .46.298c.089-.016.186-.101.716-.629l.614-.611.6.6c.636.637.693.678.889.641a.388.388 0 0 0 .298-.459c-.016-.089-.101-.186-.629-.717l-.611-.614.6-.599c.637-.636.678-.693.641-.89a.389.389 0 0 0-.459-.298c-.089.017-.186.102-.717.63l-.614.611-.586-.589c-.322-.324-.625-.606-.672-.626a.375.375 0 0 0-.316 0M2.267 7.98a.467.467 0 0 0-.001.84l.119.06h2.059c1.39 0 2.084-.009 2.134-.028a.499.499 0 0 0 .308-.456c0-.152-.06-.265-.202-.38l-.102-.083-2.098-.007-2.097-.007-.12.061m-.001 4a.467.467 0 0 0 0 .84l.119.06h5.059c3.51 0 5.082-.009 5.134-.028a.499.499 0 0 0 .308-.456c0-.152-.06-.265-.202-.38l-.102-.083-5.098-.007-5.099-.006-.119.06",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnassign);
export default __webpack_public_path__ + "static/media/icon-unassign.2ade1f3b666f644eb7973abd9ae1a967.svg";
export { ForwardRef as ReactComponent };